import { render, staticRenderFns } from "./Koatuu.vue?vue&type=template&id=30d1b11f&"
import script from "./Koatuu.vue?vue&type=script&lang=js&"
export * from "./Koatuu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports